export const Config = {
    // Contact_Form_Url:`${process.env.REACT_APP_HELPNOW_STAGING_API}public/api/v1/processContactRequest`,
    Contact_Form_Url: `${process.env.REACT_APP_HELPNOW_STAGING_API}ProcessContactController/createContactRequest`,
    Blog_Listing_Url: `${process.env.REACT_APP_HELPNOW_STAGING_API}api/v1/articles/getAllArticlesList`,
    Blog_Detail_Url: `${process.env.REACT_APP_HELPNOW_STAGING_API}api/v1/articles/getArticleById/`
}